import React, { Component } from 'react'
import { connect } from 'react-redux'
import DeviceReg from './DeviceRegistration'
import RoomSelector from './roomSelection'
import $ from "jquery"
import DeviceRegistrationPassword from './DeviceRegistrationPassword'
import { setAdminLoginPage } from '../../action/homeAction'

class AdminLoginPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            passwordRequired: true
        }
    }

    componentDidMount() {
        $("body").addClass("overlay-cast");

        if (!this.props.ecpPassword || this.props.ecpPassword == "") {
            this.setState({ passwordRequired: false })
        }
    }

    componentWillUnmount() {
        $("body").removeClass("overlay-cast");
    }

    render() {
        return (
            <section id="admin-page" className="col">
                <div id="ico-devReg" className="contentSection overUnder columns h-100 center-v">
                    <div id="devReg" className="col" style={{
                        background: "rgba(255,255,255,0.95)", marginRight: 0,
                        padding: "1rem", maxWidth: "30rem",
                        margin: "0 auto", height: "auto"
                    }}>
                        <div className="activity-heading all-caps"
                            style={{ color: "inherit" }}>{this.props.stringConst.deviceRegistration}</div>
                        { this.state.passwordRequired ?
                            <DeviceRegistrationPassword next={() => this.setState({ passwordRequired: false })} back={() => this.props.setAdminLoginPage(false)} /> :
                            this.props.CorrectIP ? <RoomSelector /> : <DeviceReg />
                        }
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => {
    return {
        CorrectIP: state.store.deviceReg.CorrectIP,
        stringConst: state.store.home.stringConst,
        ecpPassword: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.SETTING_ACTIVITY_PASSWORD : null,
        menuColor: state.store.home.MenuColor
    }
}

export default connect(
    mapStateToProps,
    {
        setAdminLoginPage
    }
)(AdminLoginPage);